import { TextInput } from "@src/appV2/redesign/components/TextInput";
import { type FieldErrors, type UseFormRegister } from "react-hook-form";

import { type CredentialsFormData } from "../api/schema";

interface TimeclockComplianceCredentialsProps {
  register: UseFormRegister<CredentialsFormData>;
  errors: FieldErrors<CredentialsFormData>;
}

export function TimeclockComplianceCredentials({
  register,
  errors,
}: TimeclockComplianceCredentialsProps) {
  return (
    <TextInput
      fullWidth
      label="Time Clock Pin"
      // FIXME: Automatically disabled during ESLint config update
      error={Boolean(errors.timeclockPin)}
      helperText={errors.timeclockPin?.message}
      inputProps={{ "data-dd-privacy": "mask" }}
      {...register("timeclockPin")}
    />
  );
}
